var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleDEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "32px",
    viewBox: "0 0 116 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_D",
    transform: "translate(-722.000000, -119.000000)",
    fill: "#EEEEEE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(514.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.443661,0 L307.467109,0 C307.734447,1.70483254e-14 307.990654,0.107044191 308.17853,0.297233997 L322.996042,15.297234 C323.380813,15.6867446 323.380813,16.3132554 322.996042,16.702766 L308.17853,31.702766 C307.990654,31.8929558 307.734447,32 307.467109,32 L209.443661,32 C208.891376,32 208.443661,31.5522847 208.443661,31 C208.443661,30.7318243 208.551375,30.4748865 208.742616,30.2868832 L222.550114,16.7131168 C222.943957,16.3259402 222.949362,15.6927983 222.562185,15.2989548 C222.558196,15.2948966 222.554172,15.2908726 222.550114,15.2868832 L208.742616,1.7131168 C208.348772,1.32594021 208.343367,0.692798299 208.730544,0.298954763 C208.918547,0.107714194 209.175485,7.15396884e-16 209.443661,0 Z",
    id: "Rectangle-Copy-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleDEmpty);
export default __webpack_public_path__ + "static/media/middleDEmpty.5736427ffad5ad03f29ddc2a7ddcef64.svg";
export { ForwardRef as ReactComponent };